<div class="settings">
    @for (optionKey of widget.options_dict | keyvalue; track optionKey.name; let idx = $index) {
        <mat-slide-toggle color="primary" [checked]="widget.options_dict[optionKey.key]"
                          [(ngModel)]="widget.options_dict[optionKey.key]">
          <span class="settings-label">
            {{ 'WIDGETS.SETTINGS_LABELS.' + optionKey.key | translate }}
          </span>
        </mat-slide-toggle>
    }
</div>